import { RouterProviderProps } from 'react-router-dom'

import env from '@core/env'

import GrafanaProvider from './grafana'
import { SentryProvider } from './sentry'

export interface ObservabilityProviderInterface {
  captureMessage(message: string): void
  captureException(error: Error): void
  setUser?(user: { id?: string } | null): void
  setContext?(
    name: string,
    context: {
      [key: string]: unknown
    } | null,
  ): void

  setup(): any
  createRouter(router): RouterProviderProps['router']
  setCypressId?(): void
}

export const tracePropagationTargetsByEnv = {
  local: [/http:\/\/localhost:8000/],
  dev: [
    /dev-hasura.generate.finetunelearning.com\/.*/,
    /api.generate.dev.ftl-nonprod.ftl-internal.com\/.*/,
  ],
  qa: [
    /qa-hasura.generate.finetunelearning.com\/.*/,
    /api.generate.qa.ftl-nonprod.ftl-internal.com\/.*/,
  ],
  staging: [
    /staging-hasura.generate.finetunelearning.com\/.*/,
    /api.generate-staging.finetunelearning.com\/.*/,
  ],
  prod: [/prod-hasura.generate.finetunelearning.com\/.*/, /api.generate.finetunelearning.com\/.*/],
  comptia: [
    /comptia-hasura.generate.finetunelearning.com\/.*/,
    /api.comptia.generate.finetunelearning.com\/.*/,
  ],
}

class ObservabilityFactory {
  static createProvider(): ObservabilityProviderInterface {
    if (env.GRAFANA_TELEMETRY_ENABLED) {
      return new GrafanaProvider()
    }
    return new SentryProvider()
  }
}

const ObservabilityProvider = ObservabilityFactory.createProvider()
export default ObservabilityProvider
